import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'filterLink',
    'imageLink',
  ]

  get imageAssets() {
    return document.querySelectorAll('[data-asset_type="image"]')
  }

  get videoAssets() {
    return document.querySelectorAll('[data-asset_type="video"]')
  }

  get imageFilterLink() {
    return document.querySelector('[data-asset_filter="image"]')
  }

  connect() {
    this.clearFilter()
    this.filterLinkTargets.forEach((el) => {
      el.addEventListener('click', this.filterAssets.bind(this))
    })
  }

  filterAssets(event) {
    event.preventDefault()
    const assetFilter = event.target.dataset.asset_filter
    this.filterLinkTargets.forEach((el) => {
      el.classList.remove('is-active')
      el.setAttribute('aria-selected', 'false')
    })
    console.log('filterAssets', assetFilter, event)
    event.target.classList.add('is-active')
    event.target.setAttribute('aria-selected', 'true')
    this.imageAssets.forEach((el) => {
      if (el.dataset.asset_type !== assetFilter) {
        el.classList.add('-is-hidden')
        console.log('hide imageAssets')
      } else {
        el.classList.remove('-is-hidden')
      }
    })
    this.videoAssets.forEach((el) => {
      if (el.dataset.asset_type !== assetFilter) {
        el.classList.add('-is-hidden')
        console.log('hide videoAssets')
      } else {
        el.classList.remove('-is-hidden')
      }
    })
    Site.lazyLoadAssets()
  }

  clearFilter() {
    this.imageFilterLink.classList.add('is-active')
    this.imageAssets.forEach((el) => el.classList.remove('-is-hidden'))
    this.videoAssets.forEach((el) => el.classList.add('-is-hidden'))
  }
}

